const config = {
  BASE_URL: "https://blog-api.apps.sagyboar.space",
};
export default config;
